<template>
    <div class="country-my" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="40"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            class="flex-column"
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span :class="$x.optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <div :class="$x.flexContainer">
            <VTextField
                ref="postalCodeField"
                v-model="address.postalCode"
                name="postalCode"
                maxlength="5"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                :class="$x.firstCol"
                class="flex-column"
                :rules="postalCodeRules"
                @input="postCodeChanged"
            ></VTextField>
            <VTextField
                ref="addressCity"
                v-model="address.city"
                class="flex-column"
                maxlength="25"
                name="city"
                required
                validate-on-blur
                :class="[$x.firstCol, { [$x['disabled']]: postCodeLookedUp }, $x['my-regions']]"
                :label="t.cityLabel"
                :readonly="postCodeLookedUp"
                :rules="cityRules"
                @input="addressUpdated"
            ></VTextField>
            <VTextField
                ref="addressRegion"
                v-model="address.region"
                name="region"
                maxlength="2"
                required
                validate-on-blur
                :label="t.regionLabel"
                :class="['flex-column', { [$x['disabled']]: postCodeLookedUp }, $x['my-regions']]"
                :rules="cityRules"
                :readonly="postCodeLookedUp"
                @input="addressUpdated"
            ></VTextField>
        </div>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import ADDRESS_MIXIN from '../addressMixin';
import POST_CODE_LOOKUP from '../postalCodeLookup';

// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressMy',
    components: {
        VTextField,
    },
    mixins: [ADDRESS_MIXIN, POST_CODE_LOOKUP],
    data() {
        return {
            zipFound: 'notLookedUp',
        };
    },
    watch: {
        zipFound() {
            if (this.zipFound === 'notFound') {
                this.postalCodeRules = [...this.postalCodeRules, this.t.invalidPostalCode];
                this.address.city = '';
                this.address.region = '';
                this.$refs.postalCodeField.blur();
                this.postCodeLookedUp = true;
            } else if (this.zipFound === 'found') {
                this.postalCodeRules = this.postalCodeRules.filter(rule => rule != this.t.invalidPostalCode);
            }
        },
    },
    mounted() {
        this.postCodeLookedUp = true;
        this.address.country = 'MY';
        this.postalCodeResetRefs = [
            this.$refs.addressCity,
            this.$refs.addressRegion,
        ];

        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
        this.$on('postal-code-looked-up', (found) => {
            this.zipFound = found ? 'found' : 'notFound';
        });
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.my-regions {
  &.disabled input{
    &:hover {
      cursor: not-allowed !important;
    }
    label,
    div {
      color: #272525 !important;
    }
  }
}

$color-eeyore: map.get(colors.$baseColors, eyore);

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .flexContainer {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
    .region {
      width: 70px;
    }
  }
}

.optional {
  color: $color-eeyore;
}
</style>
